export var HelpCenterVisibility;
(function (HelpCenterVisibility) {
    HelpCenterVisibility[HelpCenterVisibility["PUBLIC"] = 10] = "PUBLIC";
    HelpCenterVisibility[HelpCenterVisibility["USERS"] = 20] = "USERS";
    HelpCenterVisibility[HelpCenterVisibility["AGENTS"] = 30] = "AGENTS";
    HelpCenterVisibility[HelpCenterVisibility["DISABLED"] = 40] = "DISABLED";
})(HelpCenterVisibility || (HelpCenterVisibility = {}));
export var DomainMappingMethod;
(function (DomainMappingMethod) {
    DomainMappingMethod[DomainMappingMethod["SUBDOMAIN"] = 10] = "SUBDOMAIN";
    DomainMappingMethod[DomainMappingMethod["CNAME"] = 20] = "CNAME";
    DomainMappingMethod[DomainMappingMethod["PROXY"] = 30] = "PROXY";
    DomainMappingMethod[DomainMappingMethod["MULTILINGUAL_PROXY"] = 40] = "MULTILINGUAL_PROXY";
})(DomainMappingMethod || (DomainMappingMethod = {}));
//# sourceMappingURL=tenant.i.js.map